import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export const EcomalCredentialsDTORuntype = z.object({
    client_id: z.string(),
    client_secret: z.string(),
    buyer_token: z.string(),
});

export type EcomalCredentialsDTO = z.infer<typeof EcomalCredentialsDTORuntype>;

export const EcomalCredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    client_secret: z.string().optional(),
    buyer_token: z.string().optional(),
});

export type EcomalCredentialsInputDTO = z.infer<typeof EcomalCredentialsInputDTORuntype>;

export const EcomalResponseBodyDTORuntype = z.object({
    data: EcomalCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
